/*
 * @Author: lbh
 * @Date: 2020-12-29 16:12:33
 * @LastEditors: lbh
 * @LastEditTime: 2024-12-24 16:12:24
 * @Description: file content
 *
 * 舊翻譯資料來源，僅供 i18n 功能模組遷移與兼容使用
 *
 */

const legacyMessages = {
  en: {
    RiceponTitle: "Ricepon-H5",
    Menu: "Menu", //餐牌
    My_order: "My order",
    My_order_: "Order",
    Share: "Share",
    Menu_title: "Ricepon",
    Sold_out: "Sold out", //已售罄
    Sold: " Sold",
    Copy_of_the: "each",
    common: "common",
    Order: "Order",
    ShopCart: "Shopping cart", //购物车
    Empty: "Clear all",
    more: "More", //更多
    delete: "Delete",
    "Successful operation": "Successful operation!", //操作成功
    //清除购物车提示
    Prompt: "Prompt",
    Empty_cart: "Are you sure to clear all the items in cart?", //Empty cart?",
    Warning: "Warning",
    Cancel: "NO",
    Confirm: "Yes",
    Call: "Call",
    //我的订单
    Table_name: "Table name:",
    Person: "Person",
    Opening_time: "Opening time",
    Start_time: "Start time:",
    Unbind: "Unbind",
    Warm_prompt: "Reminder", //Warm prompt",
    Alert: "Reminder",
    UnbindSuccess: "Unbundling success!",
    Do_you_want_to_fix_the_order_QR: "Do you want to fix the order QR?",
    EndTime: "End time",
    LastOrderTime: "Last order time",
    Max_Number: "The maximum limit has been reached!",
    Share_the_qr_Code: "Share the qr Code",
    loading: "loading",
    loading_title: "Page load timeout, please refresh.",
    time_out_content:
      "Warm reminder: you have exceeded the order time. Thank you for coming to dinner.",
    Restaurant_list: "Restaurant list", // 餐厅列表
    Next: "Next",
    shopCartN: "Food selected",
    listA_title: "Additional Items", //"Food additive",
    "No support for the input of the system expression":
      "No support for the input of the system expression",
    "I have read and accept the terms and conditions and the privacy policy.":
      "I have read and accept the terms and conditions and the privacy policy.",
    "Have read and agreed to the Ricepon service agreement":
      "Have read and agreed to the Ricepon service agreement",
    "I have read and accept the TERMSANDCONDITIONS of BRANDNAME":
      "I have read and accept the TERMSANDCONDITIONS of BRANDNAME",
    TERMSANDCONDITIONS: "《terms and conditions》",
    Back: "Back",
    Agree: "Agree",
    "Network connection is unstable, please try again!":
      "Network connection is unstable, please try again!",
    "at TIME point ONE part": "at TIME point ONE part",
    //餐牌
    Takeout: "Delivery", //Takeaway", //外卖
    Queue: "Queue", //排队
    Reservation: "Bookind", //订座
    Pick_up: "Self pick up", //自取
    Shop_Menu: "Menu", // 餐牌
    Pre_ordering: "Pre-order", // 預點餐
    "Cold Chain Delivery": "Cold Chain Delivery",
    Amount: "Subtotal：", //"Amount",
    "Shop closed": "Shop closed",
    "Shop in Busy, delivery service not available in this moment":
      "Shop in Busy, delivery service not available in this moment",
    "Service not available at the moment, please contact the merchant":
      "Service not available at the moment, please contact the merchant",
    "Service not available at the moment":
      "Service not available at the moment",
    "The delivery function is not available, please contact the merchant.":
      "The delivery function is not available, please contact the merchant.",
    "The self-fetching function is not available, please contact the merchant":
      "The self-fetching function is not available, please contact the merchant.",
    "Please log out and try again": "Please log out and try again",
    "Also need to click $ONE food": "Also need to click $ONE food",
    "You still need to make up the difference of $ONE":
      "You still need to make up the difference of $ONE",
    "Whether to continue?": "Whether to continue?",
    "Make up the difference": "Make up the difference",
    "ONE remaining": "ONE remaining",
    "Over maximum order quantity": "Over maximum order quantity",
    // 账单小数
    "Bill Decimal": "Bill Decimal",
    appDiscount: "Discount",
    "Service amount": "Service amount",
    appTotal: "Total",
    appAmount: "Amount",
    //細項
    stop: "Stop",
    "Selection out of ONE": "Select ONE items",
    cap_Confirm: "Confirm",
    "Selection completed": "Selection completed",
    "Choose up to ONE copy": "Choose up to ONE copy",
    //外卖
    "Mobile phone number is bound": "Mobile phone number is bound",
    "Not logged in": "Not logged in",
    Order_completed: "Order completed",
    Confirm_receipt: "Confirm receipt",
    In_production: "In production",
    Awaiting_confirmation: "Awaiting confirmation",
    Again_a_single: "Again a single",
    Wait_service: "Wait service",
    Delivery_of: "Delivery of",
    "Waiting for meal": "Waiting for meal",
    Business_has_orders: "In production",
    It_has_been_served: "It has been served",
    Taken_meals: "Taken_meals",
    Submit_Order: "wait for payment",
    "Waiting for confirmation": "Waiting for confirmation",
    Order_canceled: "Order cancelled",
    Takeaway_order: "Takeaway order",
    UnOrder: "Cancel",
    Apply_for_refund: "Apply for refund",
    "Food information": "Food information",
    Remaining_QS: "$MON Remaining", // 還差多少起送
    Determine_cancellations: "Are you sure to cancel?", //"Determine cancellations",
    Cancellation_of_success: "Order cancelled", //"Cancellation of success!", //取消成功
    wm_total: "Total", //共
    wm_items: "items", //份
    wm_Total: "Total", //總金額
    "Please enter no more than 50 words": "Please enter no more than 50 words",
    "Original price": "Original price",
    "Your current address does not meet the delivery fee, please reselect":
      "Your current address does not meet the delivery fee, please reselect",
    "The selected address is not within the scope of delivery":
      "The selected address is not within the scope of delivery",
    //送單
    Confirm_the_order: "Confirm the order",
    To_pay: "Pay",
    topTitleText: "s Send again",
    Total_service: "Total:",
    "Merchant has not turned on Google Pay":
      "Merchant has not turned on Google Pay",
    "No payment method": "No payment method!",
    //餐廳列表
    "This feature is not yet supported, please download app to use":
      "This feature is not yet supported, please download app to use!",
    "Links are invalid": "Links are invalid!",
    minute: "minute",
    "Minimum consumption": "Minimum consumption",
    Freight: "Freight",
    "Not in the scope of delivery": "Not in the scope of delivery",
    "Choose a location": "location",
    "Takeaway service is not open": "Takeaway service is not open",
    "Please enter address": "Please enter address",
    "No restaurant data": "No restaurant data",
    "Choose a language": "Choose a language",
    Logout: "Logout",
    Login: "Login",
    "Confirm logout?": "Confirm logout?",
    // 收货地址
    "Add address": "Add address", //添加地址
    "Please input": "Please input", //请输入
    "Your Name": "Your Name",
    Name: "Name", //名称
    Mr: "Mr.", //先生
    Ms: "Ms.", //女士
    "Contact number": "Mobile number", //"Contact number", //联络方式
    "Receiving address": "Address", //收貨地址
    "Please choose": "Please choose", //請選擇
    "Detailed address": "Please fill in floor and unit", //"Address details",//"Detailed address", //詳細地址
    "Set as default": "Default address", //"Set as default", //設為默認
    complete: "Confirm", //"Complete", //完成
    "Please enter the name of the consignee":
      "Please enter the name of the consignee.", //收货人名称
    "Please enter contact information": "Please enter contact information.", //联系方式
    "Please enter the correct contact information":
      "Please enter the correct contact information.", //正确的联系方式
    "Please choose the receiving address":
      "Please choose the receiving address.", //收货地址
    "Please enter a detailed address": "Please enter a detailed address.", //詳細地址
    "Click for address": "Click for address",
    "Please enter your phone": "Please enter your phone",
    Default: "Default", //默认
    "Please enter your name": "Please enter your name",
    "Contact person_": "Name",
    "Delivery address": "Delivery address",
    "Choose address": "Choose address",
    "Please enter the address": "Please enter building name or street name", //"Please enter address",
    "Choose current address": "Use current address", //"Choose current address",
    "Not in the scope of delivery": "Not in the scope of delivery",
    //外卖 送单页
    "Submission of orders": "Confirm order", // "Submission of orders", //提交訂單
    "Service time": "Delivery time", //"Service time", //送達時間
    "Payment method": "Payment method", //支付方式
    "Online payment": "Online payment", //在線支付
    "Cash on delivery": "Cash on delivery", //貨到付款
    "Name of restaurant": "Name of restaurant", //餐厅名称
    remark: "Remark", //備註
    "history remark": "history remark", //历史备注
    "Taste, preference, etc": "Taste, preference, etc.", //口味、偏好等要求
    "Distribution fee": "Delivery charges", //配送费
    Coupon: "Coupon",
    "Coupon(s) available": "ONE Coupon(s) available",
    "Lunch box fee": "Lunch box fee", //餐盒费
    "Order is provided by": "The order is delivered by", //本订单由
    "Provide distribution": "", //提供配送
    "Choosing the Time of Service": "Choosing the Time of Service", //選擇送達時間
    "Served as soon as possible": "ASAP", //盡快送達
    "Please choose the time of service": "Please choose the time of service.", //請選擇送達時間
    "The shop does not support the choice of delivery time":
      "The shop does not support the choice of delivery time",
    Expected: "Expected",
    "No coupons": "No coupons",
    "Shun Feng Cold Chain": "Shun Feng Cold Chain",
    //外卖 订单详情
    "Outgoing details": "Outgoing details", //外送詳情
    "Contact person": "Contact person", //聯絡人
    Tel: "Tel", //聯絡電話
    "Order Details": "Order Details", //訂單詳情
    "Order No": "Order No", //訂單號
    Deliveryman: "Deliveryman", //送貨員
    "Solitary time": "Solitary time", //落單時間
    "Contact merchant": "Contact merchant", //联系商家
    "Total Amount": "Total Amount", //總金額
    Alipay: "Alipay", //支付寶
    WeChat: "WeChat", //微信
    AlipayHK: "AlipayHK",
    YedPayAlipay: "YedPayAlipay",
    YedPayAlipayHK: "YedPayAlipayHK",
    PayMe: "PayMe",
    "Apple pay": "Apple Pay",
    "Google pay": "Google Pay / Credit Card",
    "Discounted price": "Discount", //"Discounted price",
    "Order submitted": "Order submitted",
    "Merchant has received an order": "Merchant has received an order",
    submitted: "Submitted",
    confirmed: "Confirmed",
    Dispatching: "Delivering",
    arrived: "Arrived",
    "Order confirmed": "Order confirmed",
    "Order delivery": "Order delivery",
    "Delivery phone": "Delivery phone",
    "Delivered at TIME": "Delivered at TIME",
    "Expected to take orders at TIME": "Expected to take orders at TIME",
    "Expected to arrive at TIME": "Expected to arrive at TIME",
    "Order Created": "Order Created",
    "Order Assigned To Delivery Man": "Order Assigned To Delivery Man",
    "Delivery Man Reached Pickup Point Nearby":
      "Delivery Man Reached Pickup Point Nearby",
    "Delivery Man Reached Pickup Point": "Delivery Man Reached Pickup Point",
    "Delivery In Progress": "Delivery In Progress",
    "Delivery Man Reached Destination Nearby":
      "Delivery Man Reached Destination Nearby",
    "Order Delivered": "Order Delivered",
    "Order Assigned To Another Delivery Man":
      "Order Assigned To Another Delivery Man",
    "The driver is taking food": "The driver is taking food",
    "The merchant has confirmed that it cannot be cancelled":
      "Order confirmed, cannot cancel",
    "Meal code": "Pickup no",
    // 外卖  备注
    "Add remarks": "Add remarks",
    "Shortcut label": "Shortcut label",
    "Please enter the requirement of taste, preference and so on, and do not support the purchase of additional items on behalf of others.":
      "Please enter the requirement of taste, preference and so on, and do not support the purchase of additional items on behalf of others.",
    submit_: "Submit",
    // 在線支付
    "Pay online": "Pay online", //在线支付
    "Pay the remaining time": "Payment remaining time", //支付剩余时间
    "Confirm payment": "Confirm payment", //确认支付
    "Apple must pay more than 4": "Apple must pay more than 4",
    "Payment amount must be greater than 4":
      "Payment amount must be greater than 4",
    "Payment method 1": "Payment method",
    "Successful payment": "Successful payment",
    "Payment error, please use other ways to pay first!":
      "Payment error, please use other ways to pay first!",
    "Apple pay is not set, this payment method cannot be used!":
      "Apple pay is not set, this payment method cannot be used!",
    "Wechat is not supported temporarily":
      "Wechat is not supported temporarily",
    "Total amount: ": "Total amount: ",
    "Use mobile app scan Qr code, to pay by FPS.":
      "Use mobile app scan Qr code, to pay by FPS.",
    // 提示
    loading_in: "Loading...",
    The_maximum_limit_has_been_reached: "The maximum limit has been reached!",
    double_booking_s: "You have duplicate food, do you confirm the order?",
    double_booking:
      "You have duplicate food in FOODINTERVAL minutes, do you confirm the order?",
    Request_timeout: "Request timeout",
    net_timeout:
      "Network request timeout, please check your network and try again.",
    Order_successfully: "Order successful",
    "Add success": "Add success", //添加成功
    "Modified success": "Modified success", //修改成功
    code_content_missing:
      "Two-dimensional code content missing, please confirm and re-scan the code",
    "Data missing": "Data missing,",
    Please_quit_and_try_again: "Please quit and try again!",
    Unable_to_unbind: "Unable to unbind!",
    unbundling_msg:
      "After unbundling, will you quit the ordering page, whether to unbundle the ordering QR?",
    "Please wait for the merchant to discuss, take the meal with the meal code":
      "Please wait for the merchant to discuss, take the meal with the meal code",
    "if the meal code is not displayed, try refreshing":
      "if the meal code is not displayed, try refreshing",
    "No coupon": "No coupon",
    "No order at present": "No order at present",
    "To be evaluated / voted": "To be evaluated / voted",
    "app All": "All",
    "app Pending payment": "wait for payment",
    // mui 下拉刷新提示
    refreshUp: "Dropdown refreshes", //下拉可以刷新
    "Release refresh": "Release refresh", //釋放立即刷新
    Refreshing: "Refreshing...", //正在刷新...
    "Pull-up shows more": "Pull-up shows more", //上拉顯示更多
    "Loading...": "Loading...", //正在加載
    "No more data": "No more data", //沒有更多數據了
    // 星期
    Monday: "Monday", //周一
    Tuesday: "Tuesday", //周二
    Wednesday: "Wednesday", //周三
    Thursday: "Thursday", //周四
    Friday: "Friday", //周五
    Saturday: "Saturday", //周六
    Sunday: "Sunday", //周日
    Today: "Today", //今天
    Tomorrow: "Tomorrow", //明天
    //绑定手机号
    "Binding Mobile Phone Number": "Bind mobile number",
    msgPushSuccess: "Successful SMS Sending!",
    bindSuccess: "Binding success!",
    loginSuccess: "Login success!",
    "Enter a correct Phone Number": "Enter a correct Phone Number",
    "Phone number": "Phone number",
    "Enter verification code": "Enter verification code",
    "Send verify code": "Send verify code",
    "My coupon": "My coupon",
    cap_Cancel: "Cancel",
    "phone number 2": "Phone number",
    Captcha: "Captcha",
    "Verification code error": "Verification code error",
    // 优惠券
    "Please enter the promo code to redeem":
      "Please enter the promo code to redeem",
    exchange: "Redeem", //"exchange",
    "be usable": "Available", //"be usable",
    unavailable: "Not available", //"unavailable",
    "Rules of use": "Rules of use",
    off: "OFF",
    to: "to",
    "Over ONE available": "Over ONE available",
    "Coupon code does not exist": "Promo code not found",
    "Coupon code has been redeemed": "Promo code redemption limit reached",
    "Similar coupons are not used":
      "Please use your promo code before redeeming a new one",
    "Coupon has reached the limit of claim":
      "Promo code redemption limit reached",
    "Redeem success": "Redeem success",
    "Enter your promo code": "Enter your promo code",
    Discount: "Discount",
    "Successful redeem a coupon!": "Successful redeem a coupon!",
    Receive: "Receive",
    "Coupon saved in your wallet": "Coupon saved in your wallet",
    phone: "phone",
    address: "address",
    "Promotion Message": "Promotion Message",
    "Personal Message": "Personal Message",
    "ONE off": "ONE off",
    // gsa
    "gsa Purchase order": "Purchase order",
    "gsa Order No": "Order No",
    "gsa Supplier": "Supplier",
    "gsa Order date": "Order date",
    "gsa Order detail": "Order detail",
    "gsa Buyer party": "Buyer party",
    "gsa Delivery date": "Delivery date",
    "gsa Consignee": "Consignee",
    "gsa Address": "Address",
    "gsa Tel": "Tel",
    "gsa Food detail": "Food detail",
    "gsa No": "No",
    "gsa Name": "Name",
    "gsa UOM": "UOM",
    "gsa Unit Price": "Unit Price",
    "gsa Qty": "Qty",
    "gsa Subtotal": "Subtotal",
    "gsa Grand total": "Grand total",
    "gsa Freight": "Freight",
    "gsa Actual payable": "Actual payable",
    "gsa status": "status",
    "gsa remark": "remark",
    "gsa confirm": "Confirm",
    // app - 品牌詳情
    "Coupon for newer": "Coupon for newer",
    "Birthday concession": "Birthday concession",
    "app join": "Join",
    "app Enter": "Enter",
    "Refund processing": "Refund processing",
    "It is expected that the refund will be completed within 5-7 days":
      "It is expected that the refund will be completed within 5-7 days",
    "The refund is expected to be completed within 1-3 working days":
      "The refund is expected to be completed within 1-3 working days",
    "Refund completed": "Refund completed",
    Refunding: "Refunding",
    "Shop Order": "Shop Order",
    "Sky Order": "Sky Order",
    finished: "finished",
    "Refund progress": "Refund progress",
    "Reason for Cancellation": "Reason for Cancellation",
    Evaluation: "Evaluation",
    "Order code": "Order code",
    vote: "vote",
    "Voting history": "Voting history",
    "After the meal pay": "After the meal pay",
    // app 訂座列表
    "Booking record": "Booking record",
    "Coming soon": "Coming soon",
    Booked: "Booked",
    Seated: "Seated",
    Completed: "Completed",
    "Is it sure to delete the order?": "Is it sure to delete the order?",
    "No reservation record!": "No reservation record!",
    "Go to view": "Go to view",
    "Please use the coupon first if the number of collections reaches the upper limit":
      "Please use the coupon first if the number of collections reaches the upper limit",
    "The coupon has been received, please use the coupon first":
      "The coupon has been received, please use the coupon firs",
    "The coupon has been redeemed": "The coupon has been redeemed!",
    "please log in first": "please log in first",
    "The event is too hot, please try again later!":
      "The event is too hot, please try again later!",
    // app 意見反饋
    yesterday: "yesterday",
    "Please input your comments": "Please input your comments", //请输入你的意见
    send: "send",
    "upload pictures": "upload pictures", // 图片上传
    "Please input your opinion, thank you":
      "Please input your opinion, thank you!",

    "Submit orders": "checkout",
    "Pay at the store": "in-store pickup",
    "Self-collection time": "Pickup Time",
    "Reserved call": "Hotline",
    "Please enter reserved phone": "Please enter reserved phone",
    "In-store pickup service agreement": "In-store pickup service agreement",
    immediately: "immediately",
    "Business address": "Business address",
    "Merchant has confirmed": "Merchant has confirmed",
    "Meal available": "Meal available",
    "Meal time": "Meal time",
    "Can earn the amount of points": "Can earn the amount of points",
    "Order tracking": "Order tracking",
    "To use": "To use",
    expired: "expired",
    "Collect immediately": "Collect immediately",
    Rob: "Rob",
    "cash coupons": "現金券cash coupons",
    "Discount coupon": "Discount coupon",
    Cuisine: "Cuisine",
    filter: "filter",
    "Preferential range": "Preferential range",
    "Discount range": "Discount range",
    Received: "Received",
    // app 意見反饋
    yesterday: "yesterday",
    "Please input your comments": "Please input your comments", //请输入你的意见
    send: "send",
    "upload pictures": "upload pictures", // 图片上传
    "Please input your opinion, thank you":
      "Please input your opinion, thank you!",
    all: "All",
    //  人  app我的排队
    person: "person",
    "It's your turn.": "It's your turn.",
    "Dead number": "Dead number",
    Cancelled: "Cancelled",
    "Current call number": "Current call number",
    "The ticket time": "The ticket time",
    "Table type": "Table type",
    "Waiting tables": "Waiting tables",
    "Queuing Terms and Rules": "Queuing Terms and Rules",
    "call off line up": "call off line up",
    "After the recall can not be restored, please choose carefully!":
      "After the recall can not be restored, please choose carefully!",
    bigTable: "bigTable",
    smallTable: "smallTable",
    "Return to shopping cart": "Return to shopping cart",
    compile: "compile",
    "Choose your own time": "Choose your own time",
    "have selected": "have selected",
    "Preferential use": "Preferential use",
    sheets: "sheets",
    "Current discount": "Current discount",
    "Please input your opinion, thank you":
      "Please input your opinion, thank you!",
    all: "All",
    // pc_index
    "my shopping cart": "shopping cart",
    "Invite your menus": "Take Away Menu", // "Invite your menus",
    "No orders": "No orders",
    "Your order is empty~": "Your order is empty~",
    "Order immediately": "Order immediately",
    "Agree and read": "Agree and read",
    "all orders": "all orders",
    "Click to see the rest": "Click to see the rest",
    nape: "nape",
    // "Click on the fold": "Click on the fold",
    "in all": "in all",
    part: "part",
    "order time": "order time",
    "This group can be selected at most": "This group can be selected at most",
    kind: "kind",
    "This item is optional": "This item is optional",
    "Have discount": "Have discount",
    "Invite details": "Invite details",
    "cash coupon": "cash coupon",
    "discount coupon": "discount coupon",
    "Activity Service Terms": "Activity Service Terms",
    "I have read and agree to the Terms of procedure and the relevant privacy terms":
      "I have read and agree to the Terms of procedure and the relevant privacy terms",
    "Your order is empty": "Your order is empty～",
    "You haven't ordered your food yet": "You haven't ordered your food yet～",
    "You don't have the coupon yet": "You don't have the coupon yet～",
    "Click on the folding": "Click on the folding",
    "Delivery Menus": "Take Away Menu", // "Delivery Menus",
    "I have read and agree": "I have read and agree",
    "card collecting": "Stored printing",
    user: "user",
    "valid time": "valid time",
    "direction for use": "direction for use",
    "detail of the activity": "detail of the activity",
    "activity time": "activity time",
    register: "register",
    "Log in to view the current number of print cards":
      "Login to view stamp card",
    "The store to pay": "The store to pay",
    "address list": "address list",
    name: "name",
    "contact information": "contact information",
    operation: "operation",
    "The address details": "The address details",
    contacts: "contacts",
    "List out": "List out",
    "Delete the address": "Delete the address",
    "Are you sure you want to delete the address":
      "Are you sure you want to delete the address？",
    "Delivery Menus": "Delivery Menus",
    "Send a single time": "Send a single time",
    "Billing details": "Billing details",
    "Click share order code": "Click share order code",
    //著數專區
    Vouchers_t: "Vouchers",
    Vouchers_all: "Vouchers",
    New: "New",
    Hot: "Hot",
    Sold_3: "Sold",
    Details: "Details",
    // 套票詳情
    package_detail: "Details",
    package_Introduction: "Introduction",
    package_List: "List",
    package_BUY_NOW: "BUY NOW",
    package_to: "to",
    package_price: "price",
    "business hours": "business hours",
    "The restaurant address": "The restaurant address",
    Telephone: "Telephone",
    "Eat In": "Eat In",
    "Take Away": "Take Away",
    "Order here!": "Order here!",
    "Enjoy your meal!": "Enjoy your meal!",
    "The serviece is not available and please contact with the staff.":
      "The serviece is not available and please contact with the staff.",
    "Order without registration": "Order without registration",

    "The order has been cancelled": "Order cancelled",
    "You have to cancel": "Order cancelled",
    "cancellation of order": "Order cancelled",
    "Order details": "Order details",
    "Order No": "Order No",
    "Order notes": "Order notes",
    "You have picked up your meal.": "You have picked up your meal.",
    "Please pay at the couter and get your meal.":
      "Please pay at the couter and get your meal.",
    "Please pay at the counter, thank you!":
      "Please pay at the counter, thank you!",
    "Once you close the page, you will lose order details as you are not login. Please login account or use screenshot to save details.":
      "Once you close the page, you will lose order details as you are not login. Please login account or use screenshot to save details.",
    "Pay here": "Pay here",
    "Welcome for next visit!": "Welcome for next visit!",
    "Please show your number to pick up the meal and you can refresh the page for latest status.":
      "Please show your number to pick up the meal and you can refresh the page for latest status.",
    "to be confirmed": "to be confirmed",
    "Order type": "Order typ",
    "Eat in the store": "Eat in the store",
    "take away from": "Take Away",
    "I have read and agree_": "I agree to",
    "Sign in": "Sign in",
    "Continue to submit": "Next",
    "Your details can not be saved if you are not sign in. Please sign in or use screenshots to review details.":
      "Your details can not be saved if you are not sign in. Please sign in or use screenshots to review details.",
    "Take food information": "Details",
    "Delivery takes": "Take Away",
  },
  zh_cn: {
    RiceponTitle: "Ricepon点餐-网页版",
    Menu: "餐牌",
    My_order: "我的订单",
    My_order_: "订单",
    Share: "一起点餐",
    Menu_title: "饭团",
    Sold_out: "已售罄",
    Sold: " 已售数量",
    Copy_of_the: "份",
    common: "共",
    Order: "送单",
    ShopCart: "购物车",
    Empty: "清空",
    more: "更多", //更多
    delete: "删除",
    "Successful operation": "操作成功!", //操作成功
    Prompt: "提示",
    Empty_cart: "清空购物车?",
    Warning: "警告",
    Cancel: "取消",
    Confirm: "确定",
    Call: "呼叫",
    Table_name: "台号:",
    Person: "人数",
    Opening_time: "开台时间",
    Start_time: "开始时间:",
    Unbind: "解绑",
    Warm_prompt: "温馨提示",
    Alert: "溫馨提示",
    UnbindSuccess: "解绑成功!",
    Do_you_want_to_fix_the_order_QR: "是否解绑点餐QR?",
    EndTime: "交台时间",
    LastOrderTime: "最后落单时间",
    Max_Number: "已达到最大限制数量!",
    Share_the_qr_Code: "分享QR Code",
    loading: "刷新",
    loading_title: "页面加载超时,请刷新",
    time_out_content: "温馨提示:您已超过下单时间,感谢您光临用餐",
    Restaurant_list: "餐厅列表",
    Next: "下一步",
    shopCartN: "加购食品",
    listA_title: "加配食品",
    "No support for the input of the system expression":
      "暂不支持系统表情的输入",
    "I have read and accept the terms and conditions and the privacy policy.":
      "我已阅读并同意程序条款及相关私隐条款",
    "Have read and agreed to the Ricepon service agreement":
      "已阅读并同意Ricepon服务使用协议",
    "I have read and accept the TERMSANDCONDITIONS of BRANDNAME":
      "我已阅读并同意BRANDNAME服务TERMSANDCONDITIONS",
    TERMSANDCONDITIONS: "《使用协议》",
    Back: "返回",
    Agree: "同意",
    "Network connection is unstable, please try again!": "网络不稳,请重试!",
    "at TIME point ONE part": "在 TIME 点了 ONE 份",
    //餐牌
    Takeout: "外卖",
    Queue: "排队",
    Reservation: "订座",
    Pick_up: "自取",
    Shop_Menu: "餐牌", // 餐牌
    Pre_ordering: "预点餐", // 預點餐
    "Cold Chain Delivery": "冷冻派送",
    Amount: "金额",
    "Shop closed": "商户休息中",
    "Shop in Busy, delivery service not available in this moment": "商户繁忙中",
    "Service not available at the moment, please contact the merchant":
      "服务未开启,请联系商家",
    "Service not available at the moment": "服务未开启",
    "The delivery function is not available, please contact the merchant.":
      "外送功能不可使用,请联系商家",
    "The self-fetching function is not available, please contact the merchant":
      "自取功能不可使用,请联系商家",
    "Please log out and try again": "请退出后重试",
    "Also need to click $ONE food": "还需点选$ONE元食物",
    "You still need to make up the difference of $ONE": "您尚需补足$ONE元差价",
    "Whether to continue?": "是否继续?",
    "Make up the difference": "补差价",
    "ONE remaining": "剩余ONE份",
    "Over maximum order quantity": "超出食品组最大限制",
    "Bill Decimal": "账单小数",
    appDiscount: "折扣",
    "Service amount": "服务费",
    appTotal: "总计",
    appAmount: "总金额",
    //細項
    stop: "停",
    "Selection out of ONE": "此组最多可选ONE份",
    cap_Confirm: "确定",
    "Selection completed": "所有组别已全部选择完成",
    "Choose up to ONE copy": "最多选ONE份",
    //外卖
    "Mobile phone number is bound": "手机号已绑定",
    "Not logged in": "未登录",
    Order_completed: "订单已完成",
    Confirm_receipt: "确认收货",
    In_production: "制作中",
    Awaiting_confirmation: "等待确认",
    Again_a_single: "再来一单",
    Wait_service: "等待送达",
    Delivery_of: "派送中",
    "Waiting for meal": "待取餐",
    Business_has_orders: "制作中",
    It_has_been_served: "已送达",
    Taken_meals: "已取餐",
    Submit_Order: "等待付款",
    "Waiting for confirmation": "等待确认",
    Order_canceled: "已取消",
    Takeaway_order: "外卖订单",
    UnOrder: "取消订单",
    Apply_for_refund: "申请退款",
    "Food information": "取餐信息",
    Remaining_QS: "还差 $MON 起送",
    Determine_cancellations: "确定取消订单",
    Cancellation_of_success: "取消成功!",
    wm_total: "共", //共
    wm_items: "份", //份
    wm_Total: "总金额", //總金額
    "Please enter no more than 50 words": "请输入不超过50个字",
    "Original price": "原价",
    "Your current address does not meet the delivery fee, please reselect":
      "您当前地址未满足起送费，请重新选择",
    "The selected address is not within the scope of delivery":
      "选择的地址不在配送范围内",
    //送單
    Confirm_the_order: "确认下单",
    To_pay: "去支付",
    topTitleText: "s后可再次送单",
    Total_service: "总计:",
    "Merchant has not turned on Google Pay": "商家未开启Google Pay",
    "No payment method": "暂无支付方式!",
    //餐廳列表
    "This feature is not yet supported, please download app to use":
      "暂未支持此功能,请下载app使用!",
    "Links are invalid": "链接无效",
    minute: "分钟",
    "Minimum consumption": "最低消费",
    Freight: "运费",
    "Not in the scope of delivery": "不在配送范围",
    "Choose a location": "选择位置",
    "Takeaway service is not open": "外卖服务未开启",
    "Please enter address": "请在左上角设置地址",
    "No restaurant data": "暂无餐厅数据",
    "Choose a language": "选择语言",
    Logout: "登出",
    Login: "登入",
    "Confirm logout?": "确认退出登录?",
    // 收货地址
    "Add address": "添加地址", //添加地址
    "Please input": "请输入", //请输入
    "Your Name": "您的名字",
    Name: "名称", //名称
    Mr: "先生", //先生
    Ms: "小姐", //女士
    "Contact number": "联络方式", //联络方式
    "Receiving address": "收货地址", //收貨地址
    "Please choose": "请选择", //請選擇
    "Detailed address": "请输入楼层及单位", //"详细地址", //詳細地址
    "Set as default": "设为默认", //設為默認
    complete: "完成", //完成
    "Please enter the name of the consignee": "请输入收货人名称",
    "Please enter contact information": "请输入联络方式",
    "Please enter the correct contact information": "请输入正确的联络方式",
    "Please choose the receiving address": "请选择收货地址",
    "Please enter a detailed address": "请输入详细地址",
    "Click for address": "点击获取地址",
    "Please enter your phone": "请输入您的电话",
    Default: "默认", //默认
    "Please enter your name": "请输入您的名字",
    "Contact person_": "联络人",
    "Delivery address": "送餐地址",
    "Choose address": "选择地址",
    "Please enter the address": "请输入大厦名称或街道名称",
    "Choose current address": "选择当前地址",
    "Not in the scope of delivery": "不在配送范围内",
    //外卖 送单页
    "Submission of orders": "确认订单", //提交訂單
    "Service time": "送达时间", //送達時間
    "Payment method": "支付方式", //支付方式
    "Online payment": "在线支付", //在線支付
    "Cash on delivery": "货到付款", //貨到付款
    "Name of restaurant": "餐厅名称", //餐厅名称
    remark: "备注", //備註
    "history remark": "历史备注",
    "Taste, preference, etc": "口味、偏好等要求", //口味、偏好等要求
    "Distribution fee": "运费", //配送费
    Coupon: "优惠券",
    "Coupon(s) available": "ONE张可使用",
    "Lunch box fee": "餐盒费", //餐盒费
    "Order is provided by": "本订单由", //本订单由
    "Provide distribution": "提供配送", //提供配送
    "Choosing the Time of Service": "选择送达时间", //選擇送達時間
    "Served as soon as possible": "尽快送达", //盡快送達
    "Please choose the time of service": "请选择送达时间", //請選擇送達時間
    "The shop does not support the choice of delivery time":
      "本店不支持选择送货时间",
    Expected: "预计",
    "No coupons": "暂无优惠券",
    "Shun Feng Cold Chain": "顺丰冻链",
    //外卖 订单详情
    "Outgoing details": "外送详情", //外送詳情
    "Contact person": "联络人", //聯絡人
    Tel: "联络电话", //聯絡電話
    "Order Details": "订单详情", //訂單詳情
    "Order No": "订单号", //訂單號
    Deliveryman: "送货员", //送貨員
    "Solitary time": "落单时间", //落單時間
    "Contact merchant": "联系商家", //联系商家
    "Total Amount": "总金额", //總金額
    Alipay: "支付宝", //支付寶
    WeChat: "微信", //微信
    AlipayHK: "支付宝HK",
    YedPayAlipay: "YedPay支付宝",
    YedPayAlipayHK: "YedPay支付宝HK",
    PayMe: "PayMe",
    "Apple pay": "Apple Pay",
    "Google pay": "Google Pay / 信用卡",
    "Discounted price": "优惠金额",
    "Order submitted": "订单已提交",
    "Merchant has received an order": "商户已接单",
    submitted: "已提交",
    confirmed: "已确认",
    Dispatching: "派送中",
    arrived: "已送达",
    "Order confirmed": "订单已确认",
    "Order delivery": "订单派送中",
    "Delivery phone": "送货员电话",
    "Delivered at TIME": "预计TIME送达",
    "Expected to take orders at TIME": "预计TIME接单",
    "Expected to arrive at TIME": "预计TIME到店",
    "Order Created": "订单已创建",
    "Order Assigned To Delivery Man": "配送员已接单 ",
    "Delivery Man Reached Pickup Point Nearby": "配送员已到达店铺附近",
    "Delivery Man Reached Pickup Point": "配送员已到店",
    "Delivery In Progress": "订单正在配送中",
    "Delivery Man Reached Destination Nearby": "配送员已到达目的地附近",
    "Order Delivered": "订单已完成",
    "Order Assigned To Another Delivery Man": "已指派另一位配送员",
    "The driver is taking food": "车手取餐中",
    "The merchant has confirmed that it cannot be cancelled":
      "商家已确认,不可取消",
    "Meal code": "取餐码",
    // 外卖  备注
    "Add remarks": "添加备注",
    "Shortcut label": "快捷标签",
    "Please enter the requirement of taste, preference and so on, and do not support the purchase of additional items on behalf of others.":
      "请输入口味、偏好等要求，不支持额外代购其他物品哦～",
    submit_: "提交",
    // 在線支付
    "Pay online": "在线支付", //在线支付
    "Pay the remaining time": "支付剩余时间", //支付剩余时间
    "Confirm payment": "确认支付", //确认支付
    "Apple must pay more than 4": "苹果支付金额必须大于4",
    "Payment amount must be greater than 4": "支付金额必须大于4",
    "Payment method 1": "选择支付方式",
    "Successful payment": "支付成功",
    "Payment error, please use other ways to pay first!":
      "支付出错,清先使用其他方式支付!",
    "Apple pay is not set, this payment method cannot be used!":
      "未设置Apple Pay，无法使用此支付方式!",
    "Wechat is not supported temporarily": "暂不支持微信",
    "Total amount: ": "应付金额: ",
    "Use mobile app scan Qr code, to pay by FPS.": "使用手机FPS APP,扫码支付",
    // 提示
    loading_in: "加载中...",
    The_maximum_limit_has_been_reached: "已达到最大限制数量!",
    double_booking_s: "有重复点餐的食品,是否确认下单?",
    double_booking: "在FOODINTERVAL分钟内有重复点餐的食品,是否确认下单?",
    Request_timeout: "请求超时",
    net_timeout: "网络请求超时,请检查您的网络后重试",
    Order_successfully: "下单成功!",
    "Add success": "添加成功",
    "Modified success": "修改成功",
    code_content_missing: "二维码内容缺失，请确认后重新扫描码!",
    "Data missing": "数据缺失,",
    Please_quit_and_try_again: "请退出后重试!",
    Unable_to_unbind: "不可解绑!",
    unbundling_msg: "解绑后将会退出点餐页,是否解绑点餐QR?",
    "Please wait for the merchant to discuss, take the meal with the meal code":
      "请耐心等待商家确定,凭取餐码取餐",
    "if the meal code is not displayed, try refreshing":
      "如取餐码未显示请尝试刷新",
    "No coupon": "暂时没有优惠券",
    "No order at present": "暂时没有订单",
    "To be evaluated / voted": "点评/投票",
    "app All": "全部",
    "app Pending payment": "待付款",
    // mui 下拉刷新提示
    refreshUp: "下拉可以刷新", //下拉可以刷新
    "Release refresh": "释放立即刷新", //釋放立即刷新
    Refreshing: "正在刷新...", //正在刷新...
    "Pull-up shows more": "上拉显示更多", //上拉顯示更多
    "Loading...": "正在加载...", //正在加載
    "No more data": "没有更多数据了", //沒有更多數據了
    // 星期
    Monday: "周一", //周一
    Tuesday: "周二", //周二
    Wednesday: "周三", //周三
    Thursday: "周四", //周四
    Friday: "周五", //周五
    Saturday: "周六", //周六
    Sunday: "周日", //周日
    Today: "今天", //今天
    Tomorrow: "明天", //明天
    // 绑定手机号
    "Binding Mobile Phone Number": "绑定手机号",
    msgPushSuccess: "短信发送成功!",
    bindSuccess: "绑定成功!",
    loginSuccess: "登录成功!",
    "Enter a correct Phone Number": "请输入正确的手机号码",
    "Phone number": "请输入手机号",
    "Enter verification code": "请输入验证码",
    "Send verify code": "获取验证码",
    "My coupon": "我的优惠券",
    cap_Cancel: "取消选择",
    "phone number 2": "手机号",
    Captcha: "验证码",
    "Verification code error": "验证码错误",
    // 优惠券
    "Please enter the promo code to redeem": "请输入优惠码兑换",
    exchange: "兑换",
    "be usable": "可使用",
    unavailable: "不可使用",
    "Rules of use": "使用规则",
    off: "折",
    to: "到",
    "Over ONE available": "满ONE可用",
    "Coupon code does not exist": "优惠码不存在",
    "Coupon code has been redeemed": "优惠码已被兑换完",
    "Similar coupons are not used": "存在同类优惠券未使用",
    "Coupon has reached the limit of claim": "优惠券已达领取上限",
    "Redeem success": "兑换成功",
    "Enter your promo code": "按此输入优惠码",
    Discount: "优惠",
    "Successful redeem a coupon!": "恭喜兑换成功一张优惠券!",
    Receive: "领取",
    "Coupon saved in your wallet": "已自动存至优惠券",
    phone: "电话",
    address: "地址",
    "Promotion Message": "推广消息",
    "Personal Message": "个人消息",
    "ONE off": "已优惠ONE",
    // gsa
    "gsa Purchase order": "采购单",
    "gsa Order No": "采购订单号",
    "gsa Supplier": "供应商",
    "gsa Order date": "订单日期",
    "gsa Order detail": "订单详情",
    "gsa Buyer party": "收货方",
    "gsa Delivery date": "收货时间",
    "gsa Consignee": "收货人",
    "gsa Address": "收货地址",
    "gsa Tel": "收货电话",
    "gsa Food detail": "食材详情",
    "gsa No": "序号",
    "gsa Name": "食材名",
    "gsa UOM": "单位",
    "gsa Unit Price": "单价",
    "gsa Qty": "数量",
    "gsa Subtotal": "总价",
    "gsa Grand total": "总计",
    "gsa Freight": "运费",
    "gsa Actual payable": "实际应付",
    "gsa status": "状态",
    "gsa remark": "备注",
    "gsa confirm": "确认",
    // app - 品牌详情
    "Coupon for newer": "迎新优惠",
    "Birthday concession": "生日优惠",
    "app join": "加入品牌",
    "app Enter": "进入品牌",
    "Refund processing": "退款处理中",
    "It is expected that the refund will be completed within 5-7 days":
      "预计5-7天内退款完成",
    "The refund is expected to be completed within 1-3 working days":
      "预计1-3个工作日内退款完成",
    "Refund completed": "退款已完成",
    Refunding: "退款中",
    "Shop Order": "店铺订单",
    "Sky Order": "扫码点餐",
    finished: "已完结",
    "Refund progress": "退款进度",
    "Reason for Cancellation": "取消原因",
    Evaluation: "评价",
    "Order code": "订单码",
    vote: "投票",
    "Voting history": "投票历史",
    "After the meal pay": "餐后支付",
    // app 訂座列表
    "Booking record": "订座记录",
    "Coming soon": "即将到来",
    Cancelled: "已取消好",
    Booked: "已订座",
    Completed: "已完成",
    "Is it sure to delete the order?": "确定删除该订单?",
    "No reservation record!": "没有订座记录!",
    "Go to view": "前往查看",
    "Please use the coupon first if the number of collections reaches the upper limit":
      "领取数量达到上限,请先使用优惠券",
    "The coupon has been received, please use the coupon first":
      "已领取该优惠券,请先使用优惠券",
    "The coupon has been redeemed": "优惠券已被兑换完!",
    "please log in first": "请先登录",
    "The event is too hot, please try again later!":
      "活动太火爆了,请稍后再试试!",
    // app 意見反饋
    yesterday: "昨天",
    "Please input your comments": "请输入你的意见",
    send: "发送",
    "upload pictures": "上传图片",
    "Please input your opinion, thank you": "请输入你意见!",
    "Submit orders": "提交订单",
    "Pay at the store": "到店支付",
    "Self-collection time": "自取时间",
    "Reserved call": "预留电话",
    "Please enter reserved phone": "请输入预留电话",
    "In-store pickup service agreement": "到店自取服务协议",
    immediately: "立即",
    "Business address": "商家地址",
    "Merchant has confirmed": "商户已确认",
    "Meal available": "可以取餐",
    "Meal time": "取餐时间",
    "Can earn the amount of points": "可获取奖赏之金额",
    "Order tracking": "订单跟踪",
    "To use": "去使用",
    expired: "已过期",
    "Collect immediately": "立即領取",
    Rob: "已抢",
    "cash coupons": "现金券",
    "Discount coupon": "折扣券",
    Cuisine: "菜系",
    filter: "筛选",
    "Preferential range": "优惠范围",
    "Discount range": "折扣范围",
    Received: "已领取",

    // app 意見反饋
    yesterday: "昨天",
    "Please input your comments": "请输入你的意见",
    send: "发送",
    "upload pictures": "上传图片",
    "Please input your opinion, thank you": "请输入你意见!",
    all: "全部",
    //  人  app我的排队
    person: "人",
    "It's your turn.": "到你了",
    Seated: "已入座",
    "Dead number": "已过号",
    Cancelled: "已取消",
    "Current call number": "当前叫号",
    "The ticket time": "取票时间",
    "Table type": "餐桌类型",
    "Waiting tables": "等待桌数",
    "Queuing Terms and Rules": "排队条款及细则",
    "After the recall can not be restored, please choose carefully!":
      "取消后无法恢复，请慎重选择！",
    "call off line up": "取消排队",
    bigTable: "大桌",
    smallTable: "小桌",
    "Return to shopping cart": "返回购物车",
    compile: "编辑",
    "Choose your own time": "选择自取时间",
    "have selected": "已经选择",
    "Preferential use": "优惠使用",
    sheets: "张",
    "Current discount": "当前可优惠",
    // pc_index
    "my shopping cart": "我的购物车",
    "Invite your menus": "自取餐牌",
    "No orders": "暂无订单",
    "Your order is empty~": "您的订单空空如也～",
    "Order immediately": "立即去点餐",
    "Agree and read": "同意并阅读",
    "all orders": "全部订单",
    "Click to see the rest": "点击查看剩下",
    nape: "项",
    // "Click on the fold": "点击收起",
    "in all": "共",
    part: "份",
    "order time": "下单时间",
    "This group can be selected at most": "此组最多可选",
    kind: "种",
    "This item is optional": "此项可选可不选",
    "Have discount": "已优惠",
    "Invite details": "自取详情",
    "cash coupon": "现金券",
    "discount coupon": "折扣券",
    "Activity Service Terms": "活动服务条款",
    "I have read and agree to the Terms of procedure and the relevant privacy terms":
      "我已阅读并同意程序条款及相关私隐条款",
    "Please wait patiently for the merchant to confirm, and pick up the meal according to the meal code. If the meal code is not displayed, please try to refresh":
      "请耐心等待商家确定,凭取餐码取餐,如取餐码未显示请尝试刷新",
    "Your order is empty": "您的订单空空如也～",
    "You haven't ordered your food yet": "您还没有点选食品～",
    "You don't have the coupon yet": "您还没有优惠券～",
    "Click on the folding": "点击折叠",
    "Delivery Menus": "外送餐牌",
    "I have read and agree": "I have read and agree",
    "card collecting": "已儲印花",
    user: "用户",
    "valid time": "有效时间",
    "direction for use": "使用说明",
    "detail of the activity": "活动详情",
    "activity time": "活动时间",
    register: "登录",
    "Log in to view the current number of print cards": "登录查看印花卡",
    "The store to pay": "店内支付",
    "address list": "地址列表",
    name: "姓名",
    "contact information": "联系方式",
    operation: "操作",
    "The address details": "地址详情",
    contacts: "联系人",
    "List out": "外送列表",
    "Delete the address": "刪除地址",
    "Are you sure you want to delete the address": "确认删除地址？",
    "Delivery Menus": "外送餐牌",
    "Send a single time": "送单时间",
    "Billing details": "结算详情",
    "Click share order code": "点击分享点餐码",
    //著數專區
    Vouchers_t: "优惠专区",
    Vouchers_all: "全部餐券",
    New: "最新上线",
    Hot: "人气热销",
    Sold_3: "已售",
    Details: "了解更多",
    // 套票詳情
    package_detail: "套票详情",
    package_Introduction: "说明",
    package_List: "优惠券列表",
    package_BUY_NOW: "购买",
    package_to: "至",
    package_price: "金额",
    "business hours": "营业时间",
    "The restaurant address": "餐厅地址",
    Telephone: "电话号码",
    "Eat In": "堂食",
    "Take Away": "外送",
    "Order here!": "免排队落单",
    "Enjoy your meal!": "美食外带安心吃",
    "The serviece is not available and please contact with the staff.":
      "自助码服务未开启，请与餐厅人员联系",
    "Order without registration": "新顾客无需註册帐户都可以即时落单！",
    "The order has been cancelled": "订单已取消",
    "You have to cancel": "您已取消",
    "cancellation of order": "取消订单",
    "Order details": "订单信息",
    "Order No": "订单编号",
    "Order notes": "订单备注",
    "You have picked up your meal.": "您已取餐",
    "Please pay at the couter and get your meal.": "请顾客到柜台支付并取餐。",
    "Please pay at the counter, thank you!": "谢谢！请前往柜台支付",
    "Once you close the page, you will lose order details as you are not login. Please login account or use screenshot to save details.":
      "由于你没有登录账号，本页面关闭后你将无法再次查找订单资料。请选择登录账号或截图保存相关资料以便日后查看。",
    "Pay here": "待支付",
    "Welcome for next visit!": "欢迎下次光临！",
    "Please show your number to pick up the meal and you can refresh the page for latest status.":
      "请凭取餐码取餐。如取餐码无法显示，请刷新页面。",
    "to be confirmed": "待确认",
    "Order type": "订单类型",
    "Eat in the store": "堂食点餐",
    "take away from": "打包外带",
    "I have read and agree_": "我已阅读并同意",
    "Sign in": "用戶登录",
    "Continue to submit": "继续提交",
    "Your details can not be saved if you are not sign in. Please sign in or use screenshots to review details.":
      "由于本次操作未能储存个人资料，頁面关闭后将无法再次查询订单状况，请登录账户或截图以储存订单资料。",
    "Take food information": "取餐信息",
    "Delivery takes": "外卖自取",
  },
  zh_hk: {
    RiceponTitle: "Ricepon點餐-網頁版",
    Menu: "餐牌",
    My_order: "我的訂單",
    My_order_: "訂單",
    Share: "一起點餐",
    Menu_title: "飯糰",
    Sold_out: "已售罄", //已售罄
    Sold: " 已售數量", //已售數量
    Copy_of_the: "份",
    common: "共",
    Order: "送單",
    ShopCart: "購物車",
    Empty: "清空", //清空
    more: "更多", //更多
    delete: "刪除", //刪除
    "Successful operation": "操作成功!", //操作成功
    Prompt: "提示", //提示
    Empty_cart: "清空購物車?",
    Warning: "警告", //警告
    Cancel: "取消",
    Confirm: "確認",
    Call: "呼叫", //呼叫
    Table_name: "檯號:",
    Person: "人數",
    Opening_time: "開單時間",
    Start_time: "開始時間:",
    Unbind: "解綁",
    Warm_prompt: "溫馨提示",
    Alert: "溫馨提示",
    UnbindSuccess: "解綁成功!",
    Do_you_want_to_fix_the_order_QR: "是否解綁點餐QR?",
    EndTime: "交檯時間",
    LastOrderTime: "最後落單時間",
    Max_Number: "已達到最大限制數量!",
    Share_the_qr_Code: "分享QR Code",
    loading: "刷新",
    loading_title: "頁面加載超時,請刷新",
    time_out_content: "溫馨提示:您已超過下單時間,感謝您光臨用餐",
    Restaurant_list: "餐廳列表",
    Next: "下一步",
    shopCartN: "加購食品",
    listA_title: "加配食品",
    "No support for the input of the system expression":
      "暫不支持系統表情的輸入",
    "I have read and accept the terms and conditions and the privacy policy.":
      "我已閱讀並同意程序條款及相關私隱條款",
    "Have read and agreed to the Ricepon service agreement":
      "已閱讀並同意Ricepon服務使用協議",
    "I have read and accept the TERMSANDCONDITIONS of BRANDNAME":
      "我已閱讀並同意BRANDNAME服務TERMSANDCONDITIONS",
    TERMSANDCONDITIONS: "《使用協議》",
    Back: "返回",
    Agree: "同意",
    "Network connection is unstable, please try again!": "網絡不穩,請重試!",
    "at TIME point ONE part": "在 TIME 點了 ONE 份",
    //餐牌
    Takeout: "外送",
    Queue: "排隊",
    Reservation: "訂座",
    Pick_up: "自取",
    Shop_Menu: "餐牌", // 餐牌
    Pre_ordering: "預點餐", // 預點餐
    "Cold Chain Delivery": "冷凍派送",
    Amount: "金額",
    "Shop closed": "商戶休息中",
    "Shop in Busy, delivery service not available in this moment": "商戶繁忙中",
    "Service not available at the moment, please contact the merchant":
      "服務未開啟,請聯絡餐廳",
    "Service not available at the moment": "服務未開啟",
    "The delivery function is not available, please contact the merchant.":
      "外送功能不可使用,請聯絡餐廳",
    "The self-fetching function is not available, please contact the merchant":
      "自取功能不可使用,請聯絡餐廳",
    "Please log out and try again": "請退出後重試",
    "Also need to click $ONE food": "還需點選$ONE元食物",
    "You still need to make up the difference of $ONE": "您尚需補足$ONE元差價",
    "Whether to continue?": "是否繼續?",
    "Make up the difference": "補差價",
    "ONE remaining": "剩餘ONE份",
    "Over maximum order quantity": "超出食品組最大限制",
    "Bill Decimal": "賬單小數",
    appDiscount: "折扣",
    "Service amount": "服務費",
    appTotal: "總計",
    appAmount: "總金額",
    //細項
    stop: "停",
    "Selection out of ONE": "此組最多可選ONE份",
    cap_Confirm: "確認",
    "Selection completed": "所有組別已全部選擇完成",
    "Choose up to ONE copy": "最多選ONE份",
    //外卖
    "Mobile phone number is bound": "手機號碼已綁定",
    "Not logged in": "未登錄",
    Order_completed: "訂單已完成",
    Confirm_receipt: "確認收貨",
    In_production: "製作中",
    Awaiting_confirmation: "等待確認",
    Again_a_single: "再來一單",
    Wait_service: "等待送達",
    Delivery_of: "派送中",
    "Waiting for meal": "待取餐",
    Business_has_orders: "製作中",
    It_has_been_served: "已送達",
    Taken_meals: "已取餐",
    Submit_Order: "等待付款",
    "Waiting for confirmation": "等待確認",
    Order_canceled: "已取消",
    Takeaway_order: "外送訂單",
    UnOrder: "取消訂單",
    Apply_for_refund: "申請退款",
    "Food information": "取餐信息",
    Remaining_QS: "還差 $MON 起送",
    Determine_cancellations: "確定取消訂單",
    Cancellation_of_success: "取消成功!",
    wm_total: "共", //共
    wm_items: "份", //份
    wm_Total: "總金額", //總金額
    "Please enter no more than 50 words": "請輸入不超過50個字",
    "Original price": "原價",
    "Your current address does not meet the delivery fee, please reselect":
      "您當前地址未滿足起送費，請重新選擇",
    "The selected address is not within the scope of delivery":
      "選擇的地址不在配送範圍內",
    //送單
    Confirm_the_order: "確認下單",
    To_pay: "去支付",
    topTitleText: "s後可再次送單",
    Total_service: "總計:",
    "Merchant has not turned on Google Pay": "商家未開啟Google Pay",
    "No payment method": "暫無支付方式!",
    //餐廳列表
    "This feature is not yet supported, please download app to use":
      "暫未支持此功能,請下載app使用!",
    "Links are invalid": "鏈接無效!",
    minute: "分鐘",
    "Minimum consumption": "最低消費",
    Freight: "運費",
    "Not in the scope of delivery": "不在配送範圍",
    "Choose a location": "選擇位置",
    "Takeaway service is not open": "外送服務未開啟",
    "Please enter address": "請在左上角設置地址",
    "No restaurant data": "暫無餐廳數據",
    "Choose a language": "選擇語言",
    Logout: "登出",
    Login: "登入",
    "Confirm logout?": "確定退出登錄?",
    // 收货地址
    "Add address": "添加地址", //添加地址
    "Please input": "請輸入", //请输入
    "Your Name": "您的名字",
    Name: "名稱", //名称
    Mr: "先生", //先生
    Ms: "小姐", //女士
    "Contact number": "聯絡方式", //联络方式
    "Receiving address": "收貨地址", //收貨地址
    "Please choose": "請選擇", //請選擇
    "Detailed address": "請輸入樓層及單位", //"詳細地址", //詳細地址
    "Set as default": "設為默認", //設為默認
    complete: "完成", //完成
    "Please enter the name of the consignee": "請輸入收貨人名稱",
    "Please enter contact information": "請輸入聯絡方式",
    "Please enter the correct contact information": "請輸入正確的聯絡方式",
    "Please choose the receiving address": "請選擇收貨地址",
    "Please enter a detailed address": "請輸入詳細地址",
    "Click for address": "點擊獲取地址",
    "Please enter your phone": "請輸入您的電話",
    Default: "默認", //默认
    "Please enter your name": "請輸入您的名字",
    "Contact person_": "聯絡人",
    "Delivery address": "送餐地址",
    "Choose address": "選擇地址",
    "Please enter the address": "請輸入大廈名稱或街道名稱",
    "Choose current address": "選擇當前地址",
    "Not in the scope of delivery": "不在配送範圍內",
    //外卖 送单页
    "Submission of orders": "確認訂單", //提交訂單
    "Service time": "送達時間", //送達時間
    "Payment method": "支付方式", //支付方式
    "Online payment": "在線支付", //在線支付
    "Cash on delivery": "貨到付款", //貨到付款
    "Name of restaurant": "餐厅名称", //餐厅名称
    remark: "備註", //備註
    "Taste, preference, etc": "口味、偏好等要求", //口味、偏好等要求
    "Distribution fee": "運費", //配送费
    Coupon: "優惠券",
    "Coupon(s) available": "ONE張可使用",
    "Lunch box fee": "餐盒費",
    "Order is provided by": "本訂單由", //本订单由
    "Provide distribution": "提供配送", //提供配送
    "Choosing the Time of Service": "選擇送達時間", //選擇送達時間
    "Served as soon as possible": "盡快送達", //盡快送達
    "Please choose the time of service": "請選擇送達時間", //請選擇送達時間
    "The shop does not support the choice of delivery time":
      "本店不支持選擇送貨時間",
    Expected: "預計",
    "No coupons": "暫無優惠券",
    "Shun Feng Cold Chain": "順豐凍鏈",
    //外卖 订单详情
    "Outgoing details": "外送詳情", //外送詳情
    "Contact person": "聯絡人", //聯絡人
    Tel: "聯絡電話", //聯絡電話
    "Order Details": "訂單詳情", //訂單詳情
    "Order No": "訂單號", //訂單號
    Deliveryman: "送貨員", //送貨員
    "Solitary time": "落單時間", //落單時間
    "Contact merchant": "聯絡餐廳", //联系商家
    "Total Amount": "總金額", //總金額
    Alipay: "支付寶", //支付寶
    WeChat: "微信", //微信
    AlipayHK: "支付寶HK",
    YedPayAlipay: "YedPay支付寶",
    YedPayAlipayHK: "YedPay支付寶HK",
    PayMe: "PayMe",
    "Apple pay": "Apple Pay",
    "Google pay": "Google Pay / 信用卡",
    "Discounted price": "優惠金額",
    "Order submitted": "訂單已提交",
    "Merchant has received an order": "商戶已接單",
    submitted: "已提交",
    confirmed: "已確認",
    Dispatching: "派送中",
    arrived: "已送達",
    "Order confirmed": "訂單已確認",
    "Order delivery": "訂單派送中",
    "Delivery phone": "送貨員電話",
    "Delivered at TIME": "預計TIME送達",
    "Expected to take orders at TIME": "預計TIME接單",
    "Expected to arrive at TIME": "預計TIME到店",
    "Order Created": "訂單已創建",
    "Order Assigned To Delivery Man": "配送員已接單 ",
    "Delivery Man Reached Pickup Point Nearby": "配送員已到達店鋪附近",
    "Delivery Man Reached Pickup Point": "配送員已到店",
    "Delivery In Progress": "訂單正在配送中",
    "Delivery Man Reached Destination Nearby": "配送員已到達目的地附近",
    "Order Delivered": "訂單已完成",
    "Order Assigned To Another Delivery Man": "已指派另一位配送員",
    "The driver is taking food": "車手取餐中",
    "The merchant has confirmed that it cannot be cancelled":
      "商家已確認,不可取消",
    "Meal code": "取餐碼",
    // 外卖  备注
    "Add remarks": "添加備註",
    "Shortcut label": "快捷標籤",
    "history remark": "歷史備註",
    "Please enter the requirement of taste, preference and so on, and do not support the purchase of additional items on behalf of others.":
      "請輸入口味、偏好等要求，不支持額外代購其他物品哦～",
    submit_: "提交",
    // 在線支付
    "Pay online": "在線支付", //在线支付
    "Pay the remaining time": "支付剩餘時間", //支付剩余时间
    "Confirm payment": "確認支付", //确认支付
    "Apple must pay more than 4": "蘋果支付金額必須大於4",
    "Payment amount must be greater than 4": "支付金額必須大於4",
    "Payment method 1": "選擇支付方式",
    "Successful payment": "支付成功",
    "Payment error, please use other ways to pay first!":
      "支付出錯,請先使用其他方式支付!",
    "Apple pay is not set, this payment method cannot be used!":
      "未設置Apple Pay ,無法使用此支付方式!",
    "Wechat is not supported temporarily": "暫不支持微信",
    "Total amount: ": "應付金額: ",
    "Use mobile app scan Qr code, to pay by FPS.": "使用手機FPS APP,掃碼支付",
    // 提示
    loading_in: "加載中...",
    The_maximum_limit_has_been_reached: "已達到最大限制數量!",
    double_booking_s: "有重複點餐的食品,是否確認下單?",
    double_booking: "在FOODINTERVAL分鐘內有重複點餐的食品,是否確認下單?",
    Request_timeout: "請求超時",
    net_timeout: "網絡請求超時,請檢查您的網絡後重試",
    Order_successfully: "下單成功!",
    "Add success": "添加成功",
    "Modified success": "修改成功",
    code_content_missing: "二維碼內容缺失,請確認後重新掃碼!",
    "Data missing": "數據缺失,",
    Please_quit_and_try_again: "請退出後重試!",
    Unable_to_unbind: "不可解綁!",
    unbundling_msg: "解綁後將會退出點餐頁,是否解綁點餐QR?",
    "Please wait for the merchant to discuss, take the meal with the meal code":
      "請耐心等待商家確定,憑取餐碼取餐",
    "if the meal code is not displayed, try refreshing":
      "如取餐碼未顯示請嘗試刷新",
    "No coupon": "暫時沒有優惠券",
    "No order at present": "暫時沒有訂單",
    "To be evaluated / voted": "點評/投票",
    "app All": "全部",
    "app Pending payment": "待付款",
    // mui 下拉刷新提示
    refreshUp: "下拉可以刷新", //下拉可以刷新
    "Release refresh": "釋放立即刷新", //釋放立即刷新
    Refreshing: "正在刷新...", //正在刷新...
    "Pull-up shows more": "上拉顯示更多", //上拉顯示更多
    "Loading...": "正在加載...", //正在加載
    "No more data": "沒有更多數據了", //沒有更多數據了
    // 星期
    Monday: "週一", //周一
    Tuesday: "週二", //周二
    Wednesday: "週三", //周三
    Thursday: "週四", //周四
    Friday: "週五", //周五
    Saturday: "週六", //周六
    Sunday: "週日", //周日
    Today: "今天", //今天
    Tomorrow: "明天", //明天
    //	绑定手机号
    "Binding Mobile Phone Number": "綁定手機號碼",
    msgPushSuccess: "短信發送成功!",
    bindSuccess: "綁定成功!",
    loginSuccess: "登入成功!",
    "Enter a correct Phone Number": "請輸入正確的手機號碼",
    "Phone number": "請輸入手機號碼",
    "Enter verification code": "請輸入驗證碼",
    "Send verify code": "取得驗證碼",
    "My coupon": "我的優惠券",
    cap_Cancel: "取消選擇",
    "phone number 2": "手機號碼",
    Captcha: "驗證碼",
    "Verification code error": "驗證碼錯誤",
    // 优惠券
    "Please enter the promo code to redeem": "請輸入優惠碼兌換",
    exchange: "兌換",
    "be usable": "可使用",
    unavailable: "不可使用",
    "Rules of use": "使用規則",
    off: "折",
    to: "到",
    "Over ONE available": "滿ONE可用",
    "Coupon code does not exist": "優惠碼不存在",
    "Coupon code has been redeemed": "優惠碼已被兌換完",
    "Similar coupons are not used": "存在同類優惠券未使用",
    "Coupon has reached the limit of claim": "優惠券已達領取上限",
    "Redeem success": "兌換成功",
    "Enter your promo code": "按此輸入優惠碼",
    Discount: "優惠",
    "Successful redeem a coupon!": "恭喜兌換成功一張優惠券",
    Receive: "領取",
    "Coupon saved in your wallet": "已自動存至優惠券",
    phone: "電話",
    address: "地址",
    "Promotion Message": "推廣消息",
    "Personal Message": "個人消息",
    "ONE off": "已優惠ONE",
    // gsa
    "gsa Purchase order": "採購單",
    "gsa Order No": "採購訂單號",
    "gsa Supplier": "供應商",
    "gsa Order date": "訂單日期",
    "gsa Order detail": "訂單詳情",
    "gsa Buyer party": "收貨方",
    "gsa Delivery date": "收貨時間",
    "gsa Consignee": "收貨人",
    "gsa Address": "收貨地址",
    "gsa Tel": "收貨電話",
    "gsa Food detail": "食材詳情",
    "gsa No": "序號",
    "gsa Name": "食材名",
    "gsa UOM": "單位",
    "gsa Unit Price": "單價",
    "gsa Qty": "數量",
    "gsa Subtotal": "總價",
    "gsa Grand total": "總計",
    "gsa Freight": "運費",
    "gsa Actual payable": "實際應付",
    "gsa status": "狀態",
    "gsa remark": "備註",
    "gsa confirm": "確認",
    // app - 品牌詳情
    "Coupon for newer": "迎新優惠",
    "Birthday concession": "生日優惠",
    "app join": "加入會員",
    "app Enter": "進入會員",
    "Refund processing": "退款處理中",
    "It is expected that the refund will be completed within 5-7 days":
      "預計5-7天內退款完成",
    "The refund is expected to be completed within 1-3 working days":
      "預計1-3個工作日內退款完成",
    "Refund completed": "退款已完成",
    Refunding: "退款中",
    "Shop Order": "店鋪訂單",
    "Sky Order": "掃碼點餐",
    finished: "已完結",
    "Refund progress": "退款進度",
    "Reason for Cancellation": "取消原因",
    Evaluation: "評價",
    "Order code": "訂單碼",
    vote: "投票",
    "Voting history": "投票歷史",
    "After the meal pay": "餐後支付",
    // app 訂座列表
    "Booking record": "訂座記錄",
    "Coming soon": "即將到來",
    Cancelled: "已取消",
    Booked: "已訂座",
    Completed: "已完成",
    "Is it sure to delete the order?": "确定删除該訂單?",
    "No reservation record!": "未有訂座紀錄!",
    "Go to view": "前往查看",
    "Please use the coupon first if the number of collections reaches the upper limit":
      "領取數量達到上限,請先使用優惠券",
    "The coupon has been received, please use the coupon first":
      "已領取該優惠券,请先使用优惠券",
    "The coupon has been redeemed": "優惠券已被兌換完!",
    "please log in first": "請先登錄",
    "The event is too hot, please try again later!":
      "活動太火爆了,請稍後再試試!",
    // app 意見反饋
    yesterday: "昨天",
    "Please input your comments": "請輸入你的意見",
    send: "發送",
    "upload pictures": "圖片上傳",
    "Please input your opinion, thank you": "請輸入你的意見，謝謝！",

    "Submit orders": "提交訂單",
    "Pay at the store": "到店支付",
    "Self-collection time": "自取時間",
    "Reserved call": "聯絡電話",
    "Please enter reserved phone": "请输入聯絡電話",
    "In-store pickup service agreement": "到店自取服務協議",
    immediately: "立即",
    "Business address": "商家地址",
    "Merchant has confirmed": "商戶已確認",
    "Meal available": "可以取餐",
    "Meal time": "取餐時間",
    "Can earn the amount of points": "可獲取獎賞之金額",
    "Order tracking": "訂單跟蹤",
    "To use": "去使用",
    expired: "已過期",
    "Collect immediately": "立即領取",
    Rob: "已搶",
    "cash coupons": "現金券",
    "Discount coupon": "折扣券",
    Cuisine: "菜係",
    filter: "篩選",
    "Preferential range": "優惠範圍",
    "Discount range": "折扣範圍",
    Received: "已領取",
    // app 意見反饋
    yesterday: "昨天",
    "Please input your comments": "請輸入你的意見",
    send: "發送",
    "upload pictures": "圖片上傳",
    "Please input your opinion, thank you": "請輸入你的意見，謝謝！",
    all: "全部",
    person: "人",
    "It's your turn.": "到你了",
    Seated: "已入座",
    "Dead number": "已過號",
    "Current call number": "當前叫號",
    "The ticket time": "取票時間",
    "Table type": "餐桌類型",
    "Waiting tables": "等待桌數",
    "Queuing Terms and Rules": "排隊條款及細則",
    "call off line up": "取消排隊",
    "After the recall can not be restored, please choose carefully!":
      "取消後無法恢復，請慎重選擇!",
    bigTable: "大桌",
    smallTable: "小桌",
    "Return to shopping cart": "返回購物車",
    compile: "編輯",
    "Choose your own time": "選擇自取時間",
    "have selected": "已經選擇",
    "Preferential use": "優惠適用",
    sheets: "張",
    "Current discount": "當前可優惠",
    // pc_idex
    "my shopping cart": "我的購物車",
    "Invite your menus": "自取餐牌",
    "No orders": "暫無訂單",
    "Your order is empty~": "您的訂單空空如也～",
    "Order immediately": "立即去點餐",
    "Agree and read": "同意並閱讀",
    "all orders": "全部訂單",
    "Click to see the rest": "點擊查看剩下",
    nape: "項",
    // "Click on the fold": "點擊收起",
    "in all": "共",
    part: "份",
    "order time": "下單時間",
    "This group can be selected at most": "此組最多可選",
    kind: "種",
    "This item is optional": "此項可選可不選",
    "Have discount": "已優惠",
    "Invite details": "自取詳情",
    "cash coupon": "現金券",
    "discount coupon": "折扣券",
    "Activity Service Terms": "活動服務條款",
    "I have read and agree to the Terms of procedure and the relevant privacy terms":
      "我已閱讀並同意程序條款及相關私隱條款",
    "Please wait patiently for the merchant to confirm, and pick up the meal according to the meal code. If the meal code is not displayed, please try to refresh":
      "請耐心等待商家確定,憑取餐碼取餐,如取餐碼未顯示請嘗試刷新",
    "Your order is empty": "您的訂單空空如也～",
    "You haven't ordered your food yet": "您還沒有點選食品～",
    "You don't have the coupon yet": "您還沒有優惠券～",
    "Click on the folding": "點擊折疊",
    "Delivery Menus": "外送餐牌",
    "I have read and agree": "我已閱讀並同意",
    "card collecting": "已儲印花",
    user: "用戶",
    "valid time": "有效時間",
    "direction for use": "使用說明",
    "detail of the activity": "活動詳情",
    "activity time": "活動時間",
    register: "登錄",
    "Log in to view the current number of print cards": "登錄查看印花卡",
    "The store to pay": "店內支付",
    "address list": "地址列表",
    name: "姓名",
    "contact information": "聯繫方式",
    operation: "操作",
    "The address details": "地址詳情",
    contacts: "聯繫人",
    "List out": "外送列表",
    "Delete the address": "刪除地址",
    "Are you sure you want to delete the address": "確認刪除地址？",
    "Delivery Menus": "外送餐牌",
    "Send a single time": "送單時間",
    "Billing details": "結算詳情",
    "Click share order code": "點擊分享點餐碼",
    //著數專區
    Vouchers_t: "著數專區",
    Vouchers_all: "全部餐券",
    New: "最新上線",
    Hot: "人氣熱銷",
    Sold_3: "已售",
    Details: "了解更多",
    // 套票詳情
    package_detail: "套票詳情",
    package_Introduction: "說明",
    package_List: "優惠券列表",
    package_BUY_NOW: "購買",
    package_to: "至",
    package_price: "金額",
    "business hours": "營業時間",
    "The restaurant address": "餐廳地址",
    Telephone: "電話號碼",
    "Eat In": "堂食",
    "Take Away": "外送",
    "Order here!": "免排隊落單",
    "Enjoy your meal!": "美食外帶安心吃",
    "The serviece is not available and please contact with the staff.":
      "自助碼服務未開啟，請與餐廳人員聯繫",
    "Order without registration": "新顧客無需註冊帳戶都可以即時落單",
    "The order has been cancelled": "訂單已取消",
    "You have to cancel": "您已取消",
    "cancellation of order": "取消訂單",
    "Order details": "訂單信息",
    "Order No": "訂單編號",
    "Order notes": "訂單備註",
    "You have picked up your meal.": "您已取餐",
    "Please pay at the couter and get your meal.": "請到櫃檯支付並取餐。",
    "Please pay at the counter, thank you!": "謝謝！請前往櫃檯支付",
    "Once you close the page, you will lose order details as you are not login. Please login account or use screenshot to save details.":
      "由於你沒有登入賬戶，本頁面關閉後你將無法再次查詢訂單資料。請選擇登入賬戶或截圖保存相關資料以便日後查看。",
    "Pay here": "待支付",
    "Welcome for next visit!": "歡迎下次光臨！",
    "Please show your number to pick up the meal and you can refresh the page for latest status.":
      "請憑取餐碼取餐。如取餐碼無法顯示，請刷新頁面。",
    "to be confirmed": "待確認",
    "Order type": "訂單類型",
    "Eat in the store": "堂食點餐",
    "take away from": "打包外帶",
    "I have read and agree_": "我已閱讀並同意",
    "Sign in": "用戶登錄",
    "Continue to submit": "繼續提交",
    "Your details can not be saved if you are not sign in. Please sign in or use screenshots to review details.":
      "由於本次操作未能儲存個人資料，頁面關閉後將無法再次查詢訂單狀況，請登錄賬戶或截圖以儲存訂單資料。",
    "Take food information": "取餐信息",
    "Delivery takes": "外賣自取",
  },
};

export default legacyMessages;
